import getMailboxFolderTreeDataTable from './getMailboxFolderTreeDataTable';

export default function getFolderTreeHasMoreData(folderTreeIdentifier: string): boolean {
    const folderTreeTable = getMailboxFolderTreeDataTable();
    const folderTreeData = folderTreeTable && folderTreeTable.get(folderTreeIdentifier);
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (9,5): Type 'boolean | undefined' is not assignable to type 'boolean'.
    // @ts-expect-error
    return folderTreeData?.hasMoreData;
}
